import { PublicClientApplication } from '@azure/msal-browser';
import {
  IAppConfigurationProvider,
} from '@dirootie-core/core-types';
import { ILogger } from '@dirootie-logging/logging-types';
import {
  AuthenticationService,
  AuthorizationService,
  SessionStore,
} from '@dirootie-domain/iam';
import { IApiServiceGeneric } from '@dirootie-http/api-types';
import { IViewNavigator, ViewNavigator } from '@dirootie-web/web-apps-types';
import { IAppModule, IServiceProvider } from './modules.types';
import { IDispatcher } from '../../packages/web/elements-types/src';

export class AuthorizationModule implements IAppModule{
  constructor() {
  }
  name: string = 'authorization';

  configureServices(
    serviceProvider: IServiceProvider,
    configProvider: IAppConfigurationProvider
  ): void {
    const logger = serviceProvider.resolve<ILogger>('logger')!;
    const apiService =
      serviceProvider.resolve<IApiServiceGeneric>('api-service');
    const msalInstance =
      serviceProvider.resolve<PublicClientApplication>('msal-instance');
    const sessionStore = serviceProvider.resolve<SessionStore>('session-store');
    const navigator = serviceProvider.resolve<ViewNavigator>('navigator');
    const authorizationService = new AuthorizationService(sessionStore,navigator);
    const authenticationService = new AuthenticationService(apiService,msalInstance,authorizationService, sessionStore);
    serviceProvider.register('authorization-service',authorizationService);
    serviceProvider.register('authentication-service', authenticationService);
  }
}
